/*
    Checks if the passed value exists within a given range
    http://codegolf.stackexchange.com/questions/8649/shortest-code-to-check-if-a-number-is-in-a-range-in-javascript

    @author Christian de Wit
    @version 1.0.0
*/
export default function inRange(n, start, end = null) {
    if (end && start > end) [end, start] = [start, end];
    return end == null ? n >= 0 && n < start : n >= start && n < end;
}
